import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { map, pipe } from 'rxjs';

import { employeeFeatureKey, EmployeeState } from 'app/state/employee/employee.reducer';

export const selectEmployeeState = createFeatureSelector<EmployeeState>(employeeFeatureKey);

export const selectEmployeeList = createSelector(selectEmployeeState, (state) => state.employeeList);

export const selectEmployeeByNumber = (employeeNumber: number) =>
    pipe(
        select(selectEmployeeList),
        map((employeeList) => employeeList.find((employee) => employee.number === employeeNumber)),
    );
